import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import Footer from 'components/footer';
import { Header } from './components';
import { getUser } from 'store/user/actions';
import Spinner from 'components/spinner';
import { isAdminUser } from 'utils';

const { Content } = Layout;

const AppLayout = () => {
  const userStatus = useSelector(state => state.user.status);
  const loadingTaxis = useSelector(state => state.user.loading);
  const loadingLocales = useSelector(state => state.forms?.loadingLocales);
  const isLoading = loadingTaxis || loadingLocales;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const groups = useSelector(state => state.user.groups);

  useEffect(() => {

    dispatch(getUser());

  },[])

  const location = useLocation();
  const isStaticPage = location.pathname === "/"

  return (
    <div id="form-layout" className='form-layout'>
      {(loadingTaxis || loadingLocales) && (
        <div className="custom-spinner">
          <div>
            <Spin size="large" />
          </div>
        </div>
      )}
      <Layout id="app-layout" className="app-layout">
        <Spinner/>
        {!isStaticPage && <Header/>}
        <Content className={!isStaticPage ? "app-layout__content" : ""}>
          <Outlet />
        </Content>
      {/* <SubmitModal
        isVisible={isVisible}
        setVisible={setVisible}
        submitDisabled={submitDisabled}
        outcome={outcome}
      />
      <InvalidModal
        isVisible={invalidModalVisible}
        setVisible={setInvalidModalVisible}
      />
      <InvalidSubModal
        isVisible={invalidSubModalVisible}
        setVisible={setInvalidSubModalVisible}
      /> */}
    </Layout>
    <Footer/>
    </div>
  )
};

export default AppLayout;
